import { Atom } from 'AppReact';
import styled, { css } from "styled-components";
const template = styled.div`
    ${({ theme, displayState }) => css`
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 17px;
        text-align: ${displayState?.textAlignment};
        letter-spacing: 0.01em;
        max-height: 400px;
        overflow: auto;

        position: absolute;
        top: 50%;
        color: #ffffff;
        background: #e3dfdf;
        padding: 20px;
        border-radius: 5px;
        opacity: 1;
        font-size: 32px;
        text-stroke: 1px black;
    `
  }`;


export default Atom({ type: 'label', dataType: 'string', template })
